<div class="card p-0">
  <div class="card-header">
    <div class="card-title d-flex align-items-center">
      Accelerator Status
      <waiting-dots
        *ngIf="loading"
        class="panel-loading-indicator"
        matTooltip="Refreshing"
        aria-label="Refreshing Accelerator Status"
      ></waiting-dots>
    </div>
  </div>
  <div class="card-body px-2 py-0">
    <div class="row px-2 justify-content-center">
      <div class="col p-1" *ngFor="let element of acceleratorStatus">
        <div class="item d-flex align-items-center">
          <span class="title">{{ element.name }}</span>
          <div
            [ngClass]="getClass(element.status)"
            style="cursor: default"
            [matTooltip]="element.moreInfo || ''"
          >
            {{ element.status }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
